module.exports = __webpack_public_path__ + "burst_thumbnail_overlay-82b92327bb355edb48442f4b63946f9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/burst_thumbnail_overlay.png
// module id = 1540
// module chunks = 1